<template>
  <div class="area">
    <el-scrollbar class="page-component__scroll">
      <el-row>
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clear">
              <span>服务器信息</span>
            </div>
            <div class="card_area">
              <ul class="list">
                <li>操作系统：Linux</li>
                <li>WEB环境：nginx/1.12.2</li>
                <li>PHP版本：7.1.7</li>
                <li>PMYSQL：5.6.2</li>
              </ul>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clear">
              <span>统计</span>
            </div>
            <div class="card_area">
              <ul class="list">
                <li>用户总数量：764</li>
                <li>未激活用户数量：19</li>
                <li>文章总数：10671</li>
                <li>未审核数量：0</li>
              </ul>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clear">
              <span>用户注册</span>
            </div>
            <div class="card_area">
              <el-carousel height="200px" :autoplay="false">
                <el-carousel-item>
                  <v-chart class="chart" :options="monthRegisterData" auto-resize />
                </el-carousel-item>
                <el-carousel-item>
                  <v-chart class="chart" :options="weekRegisterData" auto-resize />
                </el-carousel-item>
                <el-carousel-item>
                  <v-chart class="chart" :options="yearRegisterData" auto-resize />
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clear">
              <span>用户充值</span>
            </div>
            <div class="card_area">
              <el-carousel height="200px" :autoplay="false">
                <el-carousel-item>
                  <v-chart class="chart" :options="weekChargeData" auto-resize />
                </el-carousel-item>
                <el-carousel-item>
                  <v-chart class="chart" :options="monthChargeData" auto-resize />
                </el-carousel-item>
                <el-carousel-item>
                  <v-chart class="chart" :options="yearChargeData" auto-resize />
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-scrollbar>
  </div>
</template>

<script>
import { dualBar, stackedLine } from "@/utils/echarts/echart-option";
export default {
  name: "index",
  data() {
    return {
      weekRegisterData: null,
      monthRegisterData: null,
      yearRegisterData: null,
      weekChargeData: null,
      monthChargeData: null,
      yearChargeData: null
    };
  },
  mounted() {
    this.getWeekRegister();
    this.getMonthRegister();
    this.getYearRegister();
    this.getWeekCharge();
    this.getMonthCharge();
    this.getYearCharge();
  },
  methods: {
    // 周注册
    getWeekRegister() {
      // 周注册
      let weekData = [
        { title: "本周", value: [0, 0, 0, 0, 0, 0, 0] },
        { title: "上周", value: [0, 0, 0, 0, 0, 0, 0] }
      ];
      let weekTime = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
      this.weekRegisterData = dualBar(weekTime, weekData);
    },
    getMonthRegister() {
      // 月注册
      let monthData = {
        date: [
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31"
        ],
        source: [
          {
            name: "本月",
            value: [
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0
            ]
          },
          {
            name: "上月",
            value: [
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0
            ]
          }
        ]
      };
      this.monthRegisterData = stackedLine(monthData);
    },
    getYearRegister() {
      // 年注册
      let yearData = {
        date: [
          "01月",
          "02月",
          "03月",
          "04月",
          "05月",
          "06月",
          "07月",
          "08月",
          "09月",
          "10月",
          "11月",
          "12月"
        ],
        source: [
          {
            name: "每月注册数",
            value: [75, 50, 66, 53, 71, 80, 43, 0, 0, 0, 0, 0]
          }
        ]
      };
      this.yearRegisterData = stackedLine(yearData);
    },
    // 充值
    getWeekCharge() {
      // 周注册
      let weekData = [
        { title: "本周", value: [0, 0, 0, 0, 0, 0, 0] },
        { title: "上周", value: [0, 0, 0, 0, 0, 0, 0] }
      ];
      let weekTime = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
      this.weekChargeData = dualBar(weekTime, weekData);
    },
    getMonthCharge() {
      // 月注册
      let monthData = {
        date: [
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31"
        ],
        source: [
          {
            name: "本月",
            value: [
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0
            ]
          },
          {
            name: "上月",
            value: [
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0
            ]
          }
        ]
      };
      this.monthChargeData = stackedLine(monthData);
    },
    getYearCharge() {
      // 年注册
      let yearData = {
        date: [
          "01月",
          "02月",
          "03月",
          "04月",
          "05月",
          "06月",
          "07月",
          "08月",
          "09月",
          "10月",
          "11月",
          "12月"
        ],
        source: [
          {
            name: "每月注册数",
            value: [75, 50, 66, 53, 71, 80, 43, 0, 0, 0, 0, 0]
          }
        ]
      };
      this.yearChargeData = stackedLine(yearData);
    }
  }
};
</script>

<style scoped>
.area {
  position: fixed;
  left: 220px;
  right: 0;
  top: 40px;
  bottom: 0;
  padding: 5px;
  z-index: 1000;
}

.box-card ul.list li {
  height: 30px;
  line-height: 30px;
}

.card_area {
  height: 200px;
}

.chart {
  width: 100%;
  height: 100%;
}
</style>